export enum FeatureFlags {
  TEST_FEATURE_FLAG = 'put_your_flag_name_here',
  SUBMIT_EXCESS_CONTRIBUTION_AP = 'submit_excess_contribution_ap',
  EOY_PLAN_RECONCILIATION = 'EOY_plan_reconciliation',
  RECEIPTS_FULL_FLOW = 'ai.receipts.full-flow',
  PURSE_LOCK_HP_UPDATE = 'integration.health-plan.purse-lock-hp-update',
  HIDE_PURSE_LOCK = 'integration.health-plan.hide-purse-lock',
  BANKING_BALANCES = 'banking.finops.banking-balance',
  MULTIPLE_EMPLOYER_IDS_REPORT = 'regtech.ap.multi-employers-reports',
  CARD_CLAIM_SUSPENSION = 'core.claim.card-claim-suspention',
  HEALTH_PLAN_RENEWAL = 'integration.health-plan.renewal-fe',
  LOCK_CARD_PURSE = 'integration.cards.lock-card-purse',
  FRAUD_PAYMENT_HOLD = 'core.fraud.payment-hold',
  USE_MY_MONEY_REIMBURSEMENT = 'ai.use-my-money.reimbursement',
  USE_MY_MONEY_SAVED_RECEIPTS = 'ai.use-my-money.saved-receipts',
  FRAUD_REVIEW_METRIC = 'regtech.ap.fraud-review-metric',
  RENEWAL_CALENDAR = 'integration.renewal.calendar',
  NEW_FILE_SEARCH = 'regtech.ap.new-file-search-endpoint',
  APPLY_UNMATCHED_PUSH = 'core.banking.apply-unmatched-push',
  DEPOSITORY_BANK_CONFIG = 'banking.organization.depository-bank-config-fe',
  RETURNED_CHECKS_LOCKBOX = 'ai.lockbox.returned-checks',
  ADMIN_AI_ASSISTANT = 'ai.assistant.admin-chat',
  CHATBOT_ZENDESK_SSO = 'ai.chatbot.zendesk-sso',
}
